import {Logger} from '#/logger'

export const logger = Logger.create(Logger.Context.Notifications)
